import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, Mail, MailCheck } from "lucide-react";
import { SunkevLogo } from "@/components/Logo";
import { Reveal } from "@/components/Reveal";

import { API } from "@/lib/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
    } catch {
      /* response is identical either way */
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <section className="flex min-h-screen items-center justify-center bg-mist px-5 pb-16 pt-28">
      <Reveal className="w-full max-w-md">
        <div className="rounded-3xl border border-gray-100 bg-white p-10 shadow-xl shadow-navy/5">
          <div className="flex justify-center">
            <SunkevLogo compact />
          </div>
          {sent ? (
            <div className="mt-8 text-center" data-testid="forgot-sent">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50">
                <MailCheck className="h-6 w-6 text-emerald-600" />
              </span>
              <h1 className="mt-6 font-heading text-2xl font-bold text-ink">Check your email</h1>
              <p className="mt-3 text-sm leading-relaxed text-fog">
                If this email is registered, a password reset link has been sent. The link
                expires in 1 hour.
              </p>
            </div>
          ) : (
            <>
              <h1 className="mt-8 text-center font-heading text-2xl font-bold text-ink">
                Forgot password?
              </h1>
              <p className="mt-2 text-center text-sm text-fog">
                Enter your admin email and we'll send a reset link
              </p>
              <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="forgot-form">
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
                  <input
                    type="email"
                    required
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email-input"
                    className="w-full rounded-xl border border-gray-200 bg-white py-3 pl-11 pr-4 text-sm text-ink outline-none transition-all duration-300 placeholder:text-gray-400 focus:border-navy focus:ring-4 focus:ring-navy/10"
                  />
                </div>
                <button
                  type="submit"
                  disabled={busy}
                  data-testid="forgot-submit-button"
                  className="flex w-full items-center justify-center gap-2 rounded-full bg-navy py-3.5 font-heading text-sm font-bold uppercase tracking-widest text-white transition-all duration-300 hover:bg-navy-800 disabled:opacity-60"
                >
                  {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Reset Link"}
                </button>
              </form>
            </>
          )}
          <p className="mt-8 text-center text-sm text-fog">
            <Link to="/login" data-testid="back-to-login" className="font-semibold text-royal hover:text-navy">
              Back to sign in
            </Link>
          </p>
        </div>
      </Reveal>
    </section>
  );
};

export default ForgotPassword;
